import h from './../../helpers/common';
import _ from 'lodash';
import { __ } from '../../translations';
import { setLockedFlag, getStreamingUrlByAssetType } from './common';
import moment from 'moment';
import channelsUtil from '../../helpers/channelsUtil';

export const transformVOD = (vod) => {
    const providers = h.getProviders();
    let contentObject = vod.media;
    let trailer = null;
    let streamingUrl = null;
    let trailerMediaUrl = null;
    if (vod?.content?.length) {
        contentObject = vod?.content;
        let trailerM3U8 = [];
        let vodStreamingUrl = [];
        let trailerMedia = [];

        trailerM3U8 = contentObject.filter((cnt) => {
            return cnt.assetTypes[0] === 'Trailer-MP4';
        });

        trailerMedia = contentObject.filter((cnt) => {
            return cnt.assetTypes[0] === 'Trailer';
        });

        vodStreamingUrl = contentObject.filter((cnt) => {
            return cnt.assetTypes[0] === 'Video' && cnt.format === 'M3U';
        });

        if (trailerM3U8.length > 0) {
            trailer = trailerM3U8[0].streamingUrl;
        }

        if (trailerMedia.length > 0) {
            trailerMediaUrl = trailerMedia[0].releases[0]?.url;
        }

        if (vodStreamingUrl.length > 0) {
            streamingUrl = vodStreamingUrl[0].releases[0] ? vodStreamingUrl[0].releases[0].url : '';
            //streamingUrl = vodStreamingUrl[0].streamingUrl;
        }
    }

    let result = {
        Id: vod?.episodeDetails ? vod?.episodeDetails.episodeId : vod.id,
        guid: vod?.episodeDetails ? vod?.episodeDetails.episodeGuid : vod.guid ? vod.guid : '',
        text: h.getLang() === 'en' ? vod.title : vod.titleLocalized.ar,
        textEn: vod.title,
        name: vod.title,
        description: h.getLang() === 'en' ? vod.description : vod.descriptionLocalized.ar,
        descriptionEn: vod.description,
        image: vod.thumbnails['portrait-highestResolution'] ? vod.thumbnails['portrait-highestResolution'].url : '',
        image_landscape: vod.thumbnails['landscape-highestResolution']
            ? vod.thumbnails['landscape-highestResolution'].url
            : '',
        year: vod.year,
        tags: vod.tags,
        genre: (!!vod.tags && _.filter(vod.tags, (i) => i.scheme === 'Genre' && i.title).map((el) => el.title)) || [],
        provider:
            (!!vod.tags &&
                _.filter(vod.tags, (i) => i.scheme === 'Categories' && i.title in providers).map((i) => i.title)) ||
            [],
        categories:
            (!!vod.tags &&
                _.filter(vod.tags, (i) => i.scheme === 'Categories' && !(i.title in providers)).map((i) => i.title)) ||
            [],
        ratings: h.getGenreRating(vod.ratings),
        duration: vod.runtime || vod?.duration,
        language: vod.languages ? vod.languages[0] : '',
        programType: vod.programType,
        tvSeasonEpisodeNumber: vod?.episodeDetails ? vod?.episodeDetails.episodeNumber : vod.tvSeasonEpisodeNumber,
        streamingUrl: streamingUrl,
        trailer: trailer,
        trailerMediaUrl: trailerMediaUrl,
        seriesId: vod.seriesId,
        tvSeasonNumber: vod?.episodeDetails ? vod?.episodeDetails.seasonNumber : vod.tvSeasonNumber,
        tvSeasonId: vod.tvSeasonId,
        subscriptionGuids: vod?.pl1$subscriptionGuids ?? vod?.subGuids ?? null,
        category: 'VOD',
        mediaId: vod.media && vod.media.length > 0 ? vod.media[0].id : null,
        promoType: false,
        introEt: vod.pl1$introEt,
        introSt: vod.pl1$introSt,
        outroEt: vod.pl1$outroEt,
        outroSt: vod.pl1$outroSt,
        timeCode: vod.timeCode ?? 0,
        vodTrailer: getStreamingUrlByAssetType(vod?.content, ['Trailer-MP4']),
        episodeDetails: vod?.episodeDetails || null,
        categoryType: vod?.pl1$categoryType ?? null,
        adEnabled: vod?.pl1$adEnabled ?? null,
    };

    result = setLockedFlag(result);

    return result;
};

export const transformResponseList = (responseData) => {
    return responseData?.entries?.map((vod) => transformVOD(vod)) || [];
};

export const transformResponse = (data, title) => {
    const entries = data.map((record) => {
        return transformVOD(record);
    });

    const lastWatchedMovieTitle = title[h.getLang()];
    return { entries, lastWatchedMovieTitle };
};

export const transformLinearResponse = (data, providers, userChannels) => {
    const dataTags = data?.tags || [];
    const m = moment(Number(data?.startTime));
    const dayLabel = m.calendar(null, {
        sameDay: '[Today]',
        nextDay: '[Tomorrow]',
        lastDay: '[Yesterday]',
        nextWeek: 'MMM DD, YYYY',
        lastWeek: 'MMM DD, YYYY',
        sameElse: 'MMM DD, YYYY',
    });
    const channel = userChannels?.channels?.find((channel) => channel?.stationURL === data?.stationId);
    const isLock = channelsUtil?.isLockedEpgChannel(channel, m.format('YYYY-MM-DD')) ?? false;
    const time = m.format('hh:mm A');
    const info = [dayLabel, time];
    const channelLogo = channel?.channelImages?.find((img) => img?.id === 'colour_svg')?.url;
    const result = {
        Id: data.id,
        paId: data.id,
        listingId: data?.listingId,
        stationId: data?.stationId,
        guid: data.guid ? data.guid : '',
        title: h.getLang() === 'en' ? data.title : data?.titleLocalized?.ar,
        textEn: data.title,
        textAR: data.titleLocalized?.ar,
        description: h.getLang() === 'en' ? data.description : data?.descriptionLocalized?.ar,
        descriptionEn: data.description,
        descriptionAr: data.descriptionLocalized?.ar,
        image: data?.thumbnails
            ? data?.thumbnails['portrait-highestResolution']
                ? data?.thumbnails['portrait-highestResolution']?.url
                : ''
            : data?.images[1]?.url,
        image_landscape: data?.thumbnails
            ? data?.thumbnails['landscape-highestResolution']
                ? data?.thumbnails['landscape-highestResolution']?.url
                : ''
            : data?.images[0]?.url,
        tags: dataTags,
        genre: dataTags.filter((i) => i.scheme === 'Genre' && i.title).map((el) => el.title),
        provider: dataTags.filter((i) => i.scheme === 'Categories' && i.title in providers).map((i) => i.title),
        categories: dataTags.filter((i) => i.scheme === 'Categories' && !(i.title in providers)).map((i) => i.title),
        ratings: h.getGenreRating(data.ratings),
        programType: data.programType,
        subscriptionGuids: data?.pl1$subscriptionGuids ?? data?.subGuids ?? null,
        startTime: data?.startTime,
        endTime: data?.endTime,
        info: info,
        isLock,
        channelLogo,
    };
    return result;
};
